import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canWrite } from '@core/utils/utils';

export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router)

  const idFlusso = (route.data['idFlusso'] as string[]) ? (route.data['idFlusso'] as string[])[0] : undefined;

  const idSidenav = (route.data['idSidenav'] as string[])
    ? (route.data['idSidenav'] as string[])[0]
    : (route.parent?.data?.['idSidenav'] as string[])
      ? (route.parent?.data?.['idSidenav'] as string[])[0]
      : '';

  if (!canWrite(idSidenav, idFlusso)) {
    router.navigate(['./home']);
    return false;
  } else return true;

};
